module.exports = require('date-fns/getDate').getDate;
